import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';

const PageHeader = ({ title, subtitle, action, backLink }) => {
  return (
    <div className="mb-6">
      {backLink && (
        <Link to={backLink.href} className="text-primary-600 hover:text-primary-800 mb-4 inline-block">
          ← {backLink.label}
        </Link>
      )}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {subtitle && (
            <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
          )}
        </div>
        {action && (
          <div>
            {React.isValidElement(action) ? (
              // If action is already a JSX element, render it directly
              action
            ) : action.href ? (
              // If action has href, render as Link
              <Button to={action.href} variant="primary">
                {action.label}
              </Button>
            ) : (
              // If action has onClick, render as button
              <Button onClick={action.onClick} variant="primary">
                {action.label}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;